module.exports = __webpack_public_path__ + "img/72.0b52f56d.jpg";